import React, {Component} from 'react';

import Search from "../core/Search";

class Anomalies extends Component {

    constructor(props) {
        super(props);

        this.externalCall = this.externalCall.bind(this);
    }

    externalCall(method) {
        if (method === "addAnomalie") {
            this.props.history.push('/admin/anomalie/');
        }
    }

    render() {
        return (
            <Search
                initData={{DATAGRID_SCREEN_ID: 103}}
                externalCall={this.externalCall} />
        );
    }
}

export default Anomalies;
